import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { filter, find, get, map } from 'lodash';

import { FontIcon, IconButton, MenuItem, SelectField } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import DatePicker from 'react-datepicker';
import { connect, useSelector } from 'react-redux';
import { Row } from 'react-flexbox-grid';

import Loading from '../../components/Loading';
import PanelMessage from '../../components/panels/PanelMessage';
import { initialize, changePeriod } from './actions';
import KTitle from '../../components/KJRN/KTitle';
import VacationTable from './VacationTable';

const labelStyle = {
  display: 'inline-block',
  padding: 12,
  color: 'white',
  marginRight: 6,
};

const VacationApprovals = ({
  vacationInitialize,
  setTimePeriod,
  datesBetween,
  start,
  end,
  error,
  hasError,
  approvalStatusTypes,
  initializeFailed,
}) => {
  const [dataSource, setDataSource] = useState([]);
  const [selectedValues, setSelectedValues] = useState({
    employeeId: [],
  });

  const {
    employees,
    loading,
    initializing,
    // initialized,
  } = useSelector(state => state.vacationApprovalsReducer);

  const {
    employeeDetailOrgList,
    employeeMaster,
  } = useSelector(state => state.profileReducer);

  useEffect(() => {
    const DefaultEmployeeDetailID = get(employeeMaster, 'DefaultEmployeeDetailID');
    if (DefaultEmployeeDetailID && employeeDetailOrgList && employeeDetailOrgList.length) {
      const defaultCompanyUnit = find(employeeDetailOrgList, unit => unit.EmployeeDetailID === DefaultEmployeeDetailID);
      setSelectedValues({ ...selectedValues, orgCompanyUnitId: get(defaultCompanyUnit, 'OrgCompanyUnitID') });
    }
  }, [employeeMaster, employeeDetailOrgList]);

  useEffect(() => {
    vacationInitialize();
  }, []);

  const filterByEmployee = () => {
    const { employeeId } = selectedValues;
    if (employeeId.length) {
      const filtered = filter(employees, e => employeeId.includes(e.EmployeeDetailID));
      return filtered.length ? filtered : employees;
    }
    return employees;
  };

  const filterData = () => {
    const data = filterByEmployee();
    setDataSource(data);
  };

  useEffect(() => {
    filterData();
  }, [selectedValues]);

  useEffect(() => {
    filterData();
  }, [employees]);

  if (initializing) return <Loading />;

  if (initializeFailed || hasError) {
    return (
      <PanelMessage
        message={<FormattedMessage id="time.initialize.error" values={{ error }} />}
        iconName="error"
        type="error"
      />
    );
  }

  const isPeriod = moment(end).format('DD/MM/YYYY') === moment(start).add(1, 'month').add(-1, 'day').format('DD/MM/YYYY');

  const isMonth = (
    moment(start).format('DD/MM/YYYY') === moment(start).startOf('month').format('DD/MM/YYYY')
    && moment(end).format('DD/MM/YYYY') === moment(end).endOf('month').format('DD/MM/YYYY')
  );

  const setLastPeriod = () => {
    if (isMonth) {
      setTimePeriod(moment(start).add(-1, 'month'), moment(end).add(-1, 'month').endOf('month'), get(selectedValues, 'orgCompanyUnitId'));
    } else if (isPeriod) {
      setTimePeriod(moment(start).add(-1, 'month'), moment(start).add(-1, 'day'), get(selectedValues, 'orgCompanyUnitId'));
    } else {
      const numberOfDays = moment(end).diff(start, 'days') + 1;
      setTimePeriod(moment(start).add(-numberOfDays, 'days'), moment(end).add(-numberOfDays, 'days'), get(selectedValues, 'orgCompanyUnitId'));
    }
  };

  const setNextPeriod = () => {
    if (isMonth) {
      setTimePeriod(moment(start).add(1, 'month'), moment(end).add(1, 'month').endOf('month'), get(selectedValues, 'orgCompanyUnitId'));
    } else if (isPeriod) {
      setTimePeriod(moment(start).add(1, 'month'), moment(start).add(2, 'month').add(-1, 'day'), get(selectedValues, 'orgCompanyUnitId'));
    } else {
      const numberOfDays = moment(end).diff(start, 'days') + 1;
      setTimePeriod(moment(start).add(numberOfDays, 'days'), moment(end).add(numberOfDays, 'days'), get(selectedValues, 'orgCompanyUnitId'));
    }
  };
  const setStartDate = (date) => {
    setTimePeriod(date, end, get(selectedValues, 'orgCompanyUnitId'));
  };

  const setEndDate = (date) => {
    setTimePeriod(start, date, get(selectedValues, 'orgCompanyUnitId'));
  };

  const getTitle = date => (
    <div style={{ textAlign: 'center' }}>
      <div>
        {date.dateString.substring(0, 5)}
      </div>
      <div>
        {date.dayOfWeek}
      </div>
    </div>
  );

  const dateTable = {
    key: 'TeriaEmployeeCafeteriaPurchaseID',
    columns: [
      { title: <FormattedMessage id="name" />, dataIndex: 'EmployeeName', width: 220 },
      ...map(datesBetween, d => ({
        title: getTitle(d), dataIndex: d.dateString, width: 40, ...d,
      })),
    ],
  };

  const onEmployeeChange = (empId) => {
    setSelectedValues({ ...selectedValues, employeeId: empId });
  };

  return (
    <React.Fragment>
      <div style={{ maxWidth: 1600, margin: 'auto' }}>
        <div>
          <KTitle containerStyle={{ marginTop: 12 }} key="hb" title={<FormattedMessage id="holiday.vacationApprovals" />} />
        </div>
        <Row middle="xs" center="xs">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingTop: 12,
              justifyContent: 'space-between',
            }}
          >
            <IconButton onClick={setLastPeriod} style={{ marginRight: 12 }}>
              <FontIcon className="material-icons">arrow_back</FontIcon>
            </IconButton>
            <span style={{ fontSize: 18, fontWeight: 400 }}>
              <DatePicker
                className="smallPicker"
                selected={moment(start)}
                onChange={setStartDate}
                dateFormat="DD.MMM YYYY"
                selectsStart
                startDate={moment(start)}
                endDate={moment(end)}
              />
              {' - '}
              <DatePicker
                selected={moment(end)}
                onChange={setEndDate}
                dateFormat="DD.MMM YYYY"
                selectsEnd
                startDate={moment(start)}
                endDate={moment(end)}
                minDate={moment(start)}
              />
            </span>
            <IconButton onClick={setNextPeriod} style={{ marginLeft: 12 }}>
              <FontIcon className="material-icons">arrow_forward</FontIcon>
            </IconButton>
          </div>
        </Row>
        <div style={{ marginTop: 12 }}>
          {map(approvalStatusTypes, type => (
            <div key={type.id} style={{ ...labelStyle, backgroundColor: type.color }}><FormattedMessage id={`holiday.${type.value}`} /></div>
          ))}
        </div>
        <Row style={{ maxWidth: 1400, margin: 'auto' }}>
          <SelectField
            multiple
            style={{ width: 280, marginRight: 12 }}
            floatingLabelFixed
            floatingLabelText={<FormattedMessage id="employee" />}
            value={get(selectedValues, 'employeeId')}
            onChange={(event, index, value) => onEmployeeChange(value)}
            disabled={loading}
          >
            {map(employees, ({ EmployeeDetailID, EmployeeName }) => (
              <MenuItem
                key={EmployeeDetailID}
                value={EmployeeDetailID}
                primaryText={EmployeeName}
                insetChildren
                checked={get(selectedValues, 'employeeId') && get(selectedValues, 'employeeId').indexOf(EmployeeDetailID) > -1}
              />
            ))}
          </SelectField>
        </Row>
        {datesBetween.length ? <VacationTable table={dateTable} entries={dataSource} /> : null}
      </div>
    </React.Fragment>
  );
};

VacationApprovals.propTypes = {
  approvalStatusTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  datesBetween: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  vacationInitialize: PropTypes.func.isRequired,
  setTimePeriod: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  initializeFailed: PropTypes.bool.isRequired,
  start: PropTypes.shape({}).isRequired,
  end: PropTypes.shape({}).isRequired,
  error: PropTypes.string,
};

VacationApprovals.defaultProps = {
  error: null,
};

export default connect(
  ({ vacationApprovalsReducer }) => ({ ...vacationApprovalsReducer }),
  dispatch => ({
    vacationInitialize: () => dispatch(initialize()),
    setTimePeriod: (from, to, unitId) => dispatch(changePeriod(from, to, unitId)),
  }),
)(VacationApprovals);



// WEBPACK FOOTER //
// ./src/sites/vacationApprovals/VacationApprovals.js